import { Currency } from "@redotech/money/currencies";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

const shippingDiscountSchema = z
  .object({
    amount: z
      .object({ currency: createEnum(Currency), value: z.string() })
      .optional(),
    percentage: z.string().optional(),
  })
  .optional();

export const updateCheckoutExperience = {
  name: "updateCheckoutExperience" as const,
  input: z.object({
    checkoutExperienceId: zExt.objectId(),
    name: z.string().optional(),
    addLandedCosts: z.boolean().optional(),
    shippingDiscount: shippingDiscountSchema.optional(),
    fulfillmentDelayDaysOverride: z
      .union([
        z.object({ operation: z.literal("set"), value: z.number() }),
        z.object({ operation: z.literal("unset") }),
      ])
      .optional(),
  }),
  output: z.null(),
};
